"use strict";

exports.__esModule = true;
exports.DeviceTagList = DeviceTagList;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DeviceTag = require("./DeviceTag");
var _excluded = ["values"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DeviceTagListView = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTagList__DeviceTagListView",
  componentId: "sc-16r2exm-0"
})(["& > *{margin-right:4px;}& > *:last-of-type{margin-right:0;}"]);

/**
 * Displays list of device tags
 */
function DeviceTagList(_ref) {
  var values = _ref.values,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(DeviceTagListView, extra, values.map(function (value) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceTag.DeviceTag, {
      value: value,
      key: value
    });
  }));
}